/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const OilWellSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.71 6.198c-.626 1.72-.89 3.415-.799 4.734.013.189.14.348.318.412l2.06.75a.5.5 0 0 0 .64-.299l1.198-3.289 1.834.668L8 18H4.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-.25v-5.552a.5.5 0 0 0 .324-.307l.342-.94a.5.5 0 0 0-.299-.64l-5.682-2.07a2 2 0 0 0-3.09-1.124l-2.034-.74 1.197-3.29a.5.5 0 0 0-.299-.64l-2.06-.75a.477.477 0 0 0-.508.112c-.918.952-1.805 2.42-2.43 4.14Zm6.856 4.755L10.889 14h2.222l-.677-3.047a2.009 2.009 0 0 1-.868 0Zm6.184 1.056-3.352-1.22L16 18h1.75v-5.991ZM10.556 15.5 10 18h4l-.556-2.5h-2.888Z" /></svg>);
const OilWellSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={OilWellSolidBase} {...rest} ref={ref} />);
export default OilWellSolid;